import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const dashboardWallboardRoute: InvariantJiraRoute = {
	name: 'dashboard-wallboard',
	path: '/jira/dashboards/wallboard',
	query: ['dashboardId', 'cyclePeriod?', 'transitionFx?', 'random?'],
	exact: true,
};
